export const parseJwt_Expired = (token) => {
    const decode = JSON.parse(atob(token.split('.')[1]));
    if (decode.exp * 1000 < new Date().getTime()) {
        localStorage.removeItem('access_token_toxometris');
        window.location.replace('/');
    }
};